export const fa = {
  locale: 'fa',
  messages: {

    // Global
    aff_logo: 'پنل نمایندگی',

    id: 'شناسه',
    name: 'نام',
    surname: 'نام خانوادگی',
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    email: 'پست الکترونیک/ایمیل',
    password: 'رمز عبور',
    registered: 'ثبت شده',
    last_login: 'آخرین ورود به سیستم',

    add_new: 'جدید اضافه کنید',
    add: 'اضافه کنید',

    next: 'بعدی',
    back: 'بازگشت',

    settings: 'تنظیمات',
    filter: 'فیلتر',
    language: 'زبان',
    state: 'وضعیت',
    currency: 'واحد پول/ارز',
    edit: 'ویرایش کردن',

    save: 'ذخیره کردن',
    cancel: 'لغو کردن',

    date: 'تاریخ',
    start_date: 'تاریخ شروع',
    end_date: 'تاریخ پایان',

    total_rows: 'مجموع ردیف ها',
    total: 'مجموع',
    summary: 'خلاصه/گزارش',
    count: 'شمردن',

    active: 'فعال',
    inactive: 'غیر فعال',
    block: 'مسدود کردن',
    blocked: 'مسدود شده',
    blocked_by_admin: 'توسط ادمین مسدود شده',

    balance: 'بالانس',
    amount: 'مقدار',

    // Statuses
    status: 'وضعیت',
    pending: 'در حال انتظار',
    waiting: 'انتظار',
    success: 'موفق',
    cancelled: 'لغو شده',
    approve: 'تایید',
    update: 'به روز رسانی',

    // Sign in
    sign_in: 'ورود به سیستم',
    go_to: 'بروید به',
    log_out: 'خروج از سیستم',

    //Sign Up
    sign_up: 'ثبت نام کردن',
    referral_id: 'شناسه ارجاع',
    company_name: 'نام شرکت',
    phone_number: 'شماره تلفن',
    account_question: 'آیا قبلا حساب کاربری داشته اید؟',

    // Forgot Password
    forgot_password: 'رمز عبور خود را فراموش کرده اید؟',
    send_verification_code: 'کد تأیید را دریافت کنید',
    recover_by: 'روش',
    verification_code_sent: 'کد تأیید با موفقیت ارسال شد.',
    password_changed: 'رمز عبور با موفقیت تغییر یافت.',
    verification_code_required: 'لطفا کد تأیید را وارد کنید',
    change_password: 'رمز  عبور را تغییر دهید',
    current_password: 'رمز عبور فعلی',
    new_password: 'رمز  عبور جدید',
    confirm_new_password: 'تایید رمز عبور جدید',
    verification_code: 'کد تایید',

    // Validation Messages
    email_required: 'لطفا ایمیل خود را وارد کنید.',
    invalid_mail: 'لطفاً یک ایمیل معتبر وارد کنید.',
    password_required: 'لطفا رمز عبور خود را وارد کنید.',
    please_confirm_password: 'لطفا رمز عبور خود را وارد کنید.',
    inconsistent_passwords: 'دو رمز عبور با هم مطابقت ندارند.',
    input_phone_number: 'لطفا شماره تلفن خود را وارد کنید.',
    invalid_phone_number: 'لطفاً یک شماره تلفن معتبر وارد کنید.',
    invalid_password: 'رمز عبور باید دارای 8 الی 15 کاراکتر بوده ، که  شامل حروف  بزرگ و  کوچک  و حداقل یک عدد و یک علامت خاص باشد.',

    only_number: 'ورودی باید فقط شامل اعداد باشد.',
    only_letters: 'ورودی باید فقط شامل حروف باشد.',
    sheba_validation: 'شماره شبا باید با "IR" شروع شود و بعد از آن شامل ۲۴ عدد بدون فاصله و یا هرکاراکتر دیگری باشد.',
    card_number_validation: 'ورودی باید شامل ۱۶ عدد باشد.',
    name_validation: 'می تواند شامل حروف و اعداد باشد.',

    confirm_password: 'رمز  عبور را تأیید کنید',
    name_validation_message: 'لطفاً یک نام معتبر وارد کنید.',
    domain_validation_message: 'لطفا یک دامنه اینترنتی معتبر وارد نمایید.',
    human: 'لطفاً تأیید کنید که ربات نیستید.',
    input_company_name: 'لطفا نام شرکت خود را وارد کنید.',
    input_referral_id: 'لطفا شناسه ارجاع را وارد کنید.',
    invalid_company_name: 'نام شرکت می تواند تنها شامل حروف بزرگ و کوچک ،اعداد،&ویک فاصله باشد.',

    required_field: 'این قسمت الزامی است.',
    required_name: 'نام الزامی است.',
    required_domain: 'نام دامنه اینترنتی الزامی است.',

    end_date_validation_message: "تاریخ شروع می بایست بزرگتر از تاریخ پایان باشد",

    // Messages Text
    success_domain: 'دامنه اینترنتی با موفقیت اضافه شد.',
    delete_domain: 'دامنه اینترنتی با موفقیت حذف شد.',
    status_changed: 'تغییر وضعیت با موفقیت انجام شد.',
    permissions_changed: 'تغییر مجوزها با موفقیت انجام شد.',

    commissions_changed: 'کمیسیون ها با موفقیت تغییر یافتند./تغییرات با موفقیت انجام شد.',
    withdraw_changed: 'وضعیت برداشت با موفقیت تغییر یافت.',

    confirm_domain_delete: 'اطمینان دارید که مایل به حذف دامنه اینترنتی می باشید',
    success_affiliate: 'نمایندگی با موفقیت اضافه شد.',
    delete_affiliate: 'نمایندگی با موفقیت حذف شد.',
    confirm_affiliate_delete: 'آیا مطمئن هستید که می خواهید نمایندگی راحذف کنید؟',

    delete_user: 'کاربر با موفقیت حذف شد.',
    update_user: 'کاربر با موفقیت به روزرسانی شد.',
    confirm_user_delete: 'آیا مطمئن هستید که می خواهید کاربر را حذف کنید.',

    // Placeholders
    affiliate_name: 'نام نمایندگی',
    type_your_name: 'نام خود را وارد کنید.',
    type_your_surname: 'نام خانوادگی خود را وارد کنید',
    type_your_referral_id: 'شناسه ارجاع را وارد کنید',
    type_your_company_name: "نام شرکت خود را وارد کنید",
    type_your_password: 'کلمه ورود خود را وارد کنید',
    type_your_email: 'ایمیل خود را وارد کنید',
    type_here: 'اینجا تایپ کنید',

    //Affiliates
    affiliates: 'نمایندگی ها',
    affiliate: 'نمایندگی ',
    aff_name: 'نام نمایندگی',
    aff: 'نمایندگی',
    owner: 'مالک',
    notes: 'یادداشت ها',
    preview: 'پیش نمایش',
    permissions: 'مجوزها',
    advance_withdraw: 'پیش پرداخت',
    none: 'هیچ کدام',
    add_remove_domains: 'اضافه کردن / حذف کردن دامنه اینترنتی',
    change_design: 'طرح را تغییر دهید',
    topup_players: 'بازیکنان برتر',
    commissions: "کمیسیون ها",
    view_players_email: "مشاهده ایمیل آدرس کاربران",

    // Reports
    reports: 'گزارش ها',
    type: 'تایپ کنید',
    game: 'بازی',
    games: 'بازی ها',

    // Withdraw
    withdraw: 'برداشت',
    withdrawable_balance: 'میزان مبلغ قابل برداشت',
    withdraw_details: 'جزئیات برداشت',
    info: 'اطلاعات',
    bank_name: 'نام بانک',
    sheba_number: 'شماره شبا',
    account_number: 'شماره حساب',
    card_number: 'شماره کارت',
    your_name: 'نام شما',

    // User
    users: 'کاربران',
    add_user: 'افزودن کاربر',
    main_partner: 'نمایندگی اصلی',
    sub_affiliate: 'زیر مجموعه نمایندگی',
    select_currency: 'واحد پول را انتخاب کنید',
    select_state: 'حالت را انتخاب کنید',
    select_type: 'نوع را انتخاب کنید',
    select_language: 'زبان مورد نظر را انتخاب کنید',
    edit_roles: 'نقش ها را ویرایش کنید',
    sub: 'زیر مجموعه',
    forever: 'برای همیشه',

    // Sign Ups
    sign_ups: 'ثبت نام ها',

    // Players
    players: 'کاربران',
    top_up: 'موجودی',
    register_start: 'تاریخ شروع را ثبت کنید',
    register_end: 'تاریخ پایان را ثبت کنید',
    login_start_date: 'شروع آخرین ورود به سیستم',
    login_end_date: 'پایان آخرین ورود به سیستم',

    // Domains
    domains: 'دامنه های اینترنتی',
    domain: 'دامنه اینترنتی',
    your_domain: 'دامنه اینترنتی شما',
    edit_domain: 'ویرایش دامنه اینترنتی',
    add_domain: 'اضافه کردن دامنه اینترنتی',
    check_activity: 'بررسی مجدد',

    // Designs
    designs: 'طرح ها',

    // Account
    account: 'حساب',
    live_chat: 'چت زنده'
  }
};

export default fa;


// WEBPACK FOOTER //
// ./src/translations/fa.js